import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-brand-offwhite" data-id="element-327">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-328">
        <div className="w-20 h-20 mx-auto bg-brand-navy text-white rounded-full flex items-center justify-center mb-6 shadow-lg border-4 border-brand-yellow" data-id="element-329">
          <Shield className="w-10 h-10" data-id="element-330" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-brand-navy mb-4 font-serif" data-id="element-331">
          30 Días de Garantía Total
        </h2>

        <p className="text-lg text-slate-700 mb-6 leading-relaxed" data-id="element-332">
          Prueba el sistema completo. Si en 30 días no ves menos berrinches, más
          calma y una mejor relación con las pantallas en tu hogar, te
          devolvemos el 100% de tu dinero.
        </p>

        <p className="font-bold text-brand-red text-xl" data-id="element-333">
          Sin preguntas. Sin complicaciones. El riesgo es todo nuestro.
        </p>
      </div>
    </section>;
}